<template>
     <div
      id="loader"
      class="animate__animated animate__pulse animate__infinite"
    ></div>
</template>

<script>
    export default {
        name: 'CallBack',
        async created() {
            try {
                var result = await this.$root.mgr.signinRedirectCallback();
                var returnToUrl = '/';                 

                if (localStorage["Route"]!=null)
                {
                    returnToUrl = localStorage["Route"];
                }

                if (localStorage["ReturnUrl"] != null && localStorage["ReturnUrl"] != undefined)
                {
                    returnToUrl = returnToUrl + '?' + localStorage["ReturnUrl"];
                }

                if (result.state !== undefined) { returnToUrl = result.state;}
                this.$router.push({ path: returnToUrl });
            } catch (e) {
                console.log(e);
                this.$router.push({ name: localStorage["Route"] });
            }
        }
    }
</script>
<style>
      /* Center the loader */
      #loader {
        position: absolute;
        left: 40%;
        top: 40%;
        z-index: 1;
        width: 208px;
        height: 58px;
        background-image: url("https://www.microchip.com/ResourcePackages/Microchip/assets/dist/images/logo.png");
      }
      </style>